<template>
	<div>
		<TaskView
			:isTasklist="false"
			:color="$attrs.color"
			:viewOptions="view_options"
			:dayOfType="day_of_type"
			:typesInit="type"
			:viewOptionsInit="options"
			@create="onCreate($event)"
			@switch="onCalendarSwitch()"
			@type="onTypeChange($event)"
			@options="onOptionsChange($event)"
			@data-picker="dataPickerVisible = true"
		/>
		<v-alert class="mx-6 mt-3" type="error" v-if="error_msg.length !== 0">
			{{ error_msg }}
		</v-alert>
		<ProgressLinear v-if="loading"/>
		<Calendar
			v-if="!loading"
			v-model="dataPickerVisible"
			:key="`calendar_0`"
			:color="$attrs.color"
			:viewOptions="view_options"
			:daysOfType="day_of_type"
			:type="type_save"
			:options="options_save"
			:display="display"
			:calendar="calendar"
			:isPrivilege="privileges.includes(privilege_tr)"
			:privileges="privileges"
			:reload="$attrs.reload"
			:calendarIndex="calendar_index"
			@stop_recording="$emit('stop_recording')"
			@type="onTypeChange($event)"
			@options="onOptionsChange($event)"
			@display="onDisplayChange($event)"
			@calendar="onCalendarChange($event)"
			@create="onCreate($event)"
		/>
		<CreateEventDialog
			v-if="create_obj.length !== 0"
			:visible="create_obj.length !== 0"
			:createObj="create_obj"
			:color="$attrs.color"
			@close="onCreateEventDialogClose()"
		/>
		<v-fab-transition v-if="$vuetify.breakpoint.smAndDown">
			<v-btn
				class="create-btn"
				:color="$attrs.color"
				fab
				dark
				small
				bottom
				right
				@click="onCreate(null)"
			>
				<v-icon>mdi-plus</v-icon>
			</v-btn>
		</v-fab-transition>
	</div>
</template>

<script>
import TaskView from "@/views/tasks/task_view.vue";
import Calendar from "@/views/timesheets/calendar.vue";
import CreateEventDialog from "@/views/timesheets/create_event_dialog.vue";
import ProgressLinear from "@/components/progress/progress_getdata_linear.vue";
import config from "@/config.js";

const Weekends = 'weekends';
const Event_Task = 'task';
const Event_Task_Active = 'active_task';
const Event_Task_Completed = 'completed_task';
const Event_Timesheet = 'timesheet';
const Event_Events = 'events';
const Event_Holiday = 'holiday';
const Event_Leave = 'leave';
const Event_Item = 'item';
const ALLEMPLOYEES = 2;


const ViewOptions = [
	{
		text: 'Weekends',
		value: Weekends
	},
	{
		text: 'Events',
		value: Event_Events
	},
	{
		text: 'Active Tasks',
		value: Event_Task_Active
	},
	{
		text: 'Completed Tasks',
		value: Event_Task_Completed
	},
	{
		text: 'Timesheets',
		value: Event_Timesheet
	},
	{
		text: 'Public Holidays',
		value: Event_Holiday
	},
	{
		text: 'Leave',
		value: Event_Leave
	},
	{
		text: 'Items',
		value: Event_Item
	},
];

const DaysOfType = [
	{
		text: 'Day',
		value: 'day'
	},
	{
		text: '3 Days',
		value: 'custom-daily'
	},
	{
		text: '1 Week',
		value: 'week'
	},
	{
		text: '2 Weeks',
		value: 'custom-weekly'
	},
	{
		text: 'Month',
		value: 'month'
	}
];

const CREATE_ITEMS = config.create_items;

/* the user will be able to create and amend tasks */
const TR = 'TR';
/* the user will be able to enter and amend Items Charges */
const CH = 'CH';
/* If selected the user can manage public holidays */
const DPubHol = 'DPubHol';

const MENU_WINNAME = 'Menu';


export default {
	name: 'TimeSheets',
	data() {
		return {
			privilege_tr: TR,
			view_options: ViewOptions,
			day_of_type: DaysOfType,

			loading: false,
			error_msg: '',
			userId: 0,
			calendar_index: 0,
			create_obj: [],
			dataPickerVisible: false,
			
			
			type: 'week',
			options: ViewOptions.filter(v => { return v.value !== Weekends }),

			type_save: 'week',
			options_save: ViewOptions.filter(v => { return v.value !== Weekends }),

			display: [],
			display_save: [],

			calendar: true,
			calendar_save: true,
		}
	},
	components: {
		TaskView,
		Calendar,
		CreateEventDialog,
		ProgressLinear
	},
	async created() {
		await this.getUserId();

		this.$watch(
			() => this.$route.name,
			() => {
				this.getSettings()
			},
			{ immediate: true }
		)

		this.$store.commit("push_breadcrumb", {
			exact: true,
			text: 'Calendar',
			to: this.$route.path
		});
	},
	computed: {
		privileges () {
			return this.$store.state.privileges;
		},
	},
	methods: {
		async getUserId() {
			this.loading = true;

			const url = '/api/user/me';
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.userId = data.id;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
		},
		getSettings() {
			this.loading = true;
			const usid = this.userId;
			const winname_tmp = this.$route.name;
			const winname = config.win_name[`${winname_tmp}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const current_settings = data.filter(d => { return d.user_id === usid });
							const settings_winname = current_settings[0].window_name;
							const settings_windata_json = current_settings[0].windata_json;
							if (settings_winname === winname) {
								const windata = JSON.parse(settings_windata_json);
								const type = windata.type;
								if (type) {
									this.type = windata.type;
									this.type_save = windata.type;
								}

								const options = windata.options;
								if (options) {
									this.options = windata.options;
									this.options_save = windata.options;

									/** init 'options' and 'options_save', due to change the list */
									const task_options_filter = windata.options.filter(o => { return o.value === Event_Task });
									const task_active_options_filter = windata.options.filter(o => { return o.value === Event_Task_Active });
									const task_completed_options_filter = windata.options.filter(o => { return o.value === Event_Task_Completed });

									if (task_options_filter.length !== 0 && task_active_options_filter.length === 0 && task_completed_options_filter.length === 0) {
										if (windata.task && windata.task.length !== 0) {
											const task_incompleted = windata.task.filter(t => { return t.value === config.task_incomplete });
											if (task_incompleted.length !== 0) {
												const obj = {
													text: 'Active Tasks',
													value: 'active_task'
												};

												this.options.push(obj);
												this.options_save = this.options;
											}

											const task_completed = windata.task.filter(t => { return t.value === config.task_completed });
											if (task_completed.length !== 0) {
												const obj = {
													text: 'Completed Tasks',
													value: 'completed_task'
												};

												this.options.push(obj);
												this.options_save = this.options;
											}
										} else {
											const obj = {
												text: 'Active Tasks',
												value: 'active_task'
											};

											this.options.push(obj);
											this.options_save = this.options;
										}
									}
								}

								this.display = windata.display ? windata.display : [];
								this.display_save = windata.display ? windata.display : [];

								/** will remove until shows roles and department */
								this.display = this.display.filter(d => { return d.type === ALLEMPLOYEES });
								this.display_save = this.display_save.filter(d => { return d.type === ALLEMPLOYEES });

								this.calendar = windata.calendar !== undefined ? windata.calendar : true;
								this.calendar_save = windata.calendar !== undefined ? windata.calendar : true;
							}
						}
						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		updateSettings(win_setup) {
			const usid = this.$store.state.user.id;
			const winname_tmp = this.$route.name;
			const winname = config.win_name[`${winname_tmp}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;

			const params_obj = {};
			params_obj['value'] = win_setup;

			return new Promise((resolve, reject) => {
				axios
					.post(url, params_obj, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						}
					})
					.then((val) => {
						const json = val.data;

						const { status, data, reason } = json;

						if (status == "OK") {
							resolve(data);
						} else {
							reject(reason);
						}
					})
					.catch((e) => {
						reject(e.message);
					});
			});			
		},
		onCreate(create_obj) {
			if (create_obj) {
				this.create_obj = create_obj;
			} else {
				let create_items = CREATE_ITEMS;
				if (!this.privileges.includes(TR)) {
					create_items = create_items.filter(c => {return c.value !== Event_Task});
				}
				if (!this.privileges.includes(CH)) {
					create_items = create_items.filter(c => {return c.value !== Event_Item});
				}
				if (!this.privileges.includes(DPubHol)) {
					create_items = create_items.filter(c => {return c.value !== Event_Holiday});
				}
				
				this.create_obj = create_items;
			}
		},
		onCreateEventDialogClose() {
			this.create_obj = [];
			this.calendar_index += 1;
			this.options = this.options_save;
			this.type = this.type_save;
			this.display = this.display_save;
			this.calendar = this.calendar_save;
		},
		onCalendarSwitch() {
			const to_router = '/tasks/tasklist/0';
			const win_setup_obj = { to: to_router };
			const win_setup = JSON.stringify(win_setup_obj);

			const usid = this.$store.state.user.id;
			const winname_tmp = MENU_WINNAME;
			const winname = config.win_name[`${winname_tmp}`];

			const url = `/api/user/${usid}/webwinsetup/${winname}`;
			const params_obj = {};
			params_obj['value'] = win_setup;

			axios
				.post(url, params_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					const { status, reason } = json;

					if (status == "OK") {
					} else {
						console.log(reason)
					}
				})
				.catch((e) => {
					console.log(e.message)
				});

			this.$router.push({ name: "Tasks", params: { id: '0' }});
		},
		onTypeChange(type) {
			this.type_save = type;

			const win_setup_str = this._setWinSetup();
			
			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onOptionsChange(options) {
			this.options_save = options;

			const win_setup_str = this._setWinSetup();

			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onDisplayChange(display) {
			this.display_save = display;

			const win_setup_str = this._setWinSetup();

			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		onCalendarChange(calendar) {
			this.calendar_save = calendar;

			const win_setup_str = this._setWinSetup();

			this.updateSettings(win_setup_str)
				.then(() => {
				})
				.catch((reason) => {
					this.error_msg = reason;
				});
		},
		_setWinSetup() {
			const win_setup_obj = {
				type: this.type_save,
				options: this.options_save.filter(o => { return o.value !== Event_Task }),
				display: this.display_save,
				calendar: this.calendar_save,
			};

			const win_setup_str = JSON.stringify(win_setup_obj);
			return win_setup_str;
		}
	}
}
</script>
<style lang="scss" scoped>
.create-btn {
	position: fixed;
	bottom: 16px;
	right: 16px;
	z-index: 14;
}
</style>